// translations/pages/team/fi.js
// Texts of the team overview and of the navigation inside a profile. The
// profiles themselves come from src/profile (one folder per member).
export const teamPageFI = {
  hero: {
    title: 'Tiimi',
    intro: 'Adrian Eisenmeier ja Nikolai Genov ovat perustaneet pAIoneer Labs GmbH:n ja johtavat sitä toimitusjohtajina.',
    members: 'Adrian Eisenmeier on diplomifyysikko ja rakentaa järjestelmiä siellä, missä tekoäly, ohjelmistoarkkitehtuuri, tietosuoja ja tietoturva kohtaavat. Nikolai Genov on bioinformatiikan tohtori ja tekninen vetäjä tekoälyavusteisessa ohjelmistokehityksessä ja analytiikassa säännellyissä terveydenhuollon, biotieteiden ja rahoitusalan ympäristöissä. Alina Tselinina on ohjelmistokehittäjä ja datainsinööri, jolla on maisterin tutkinto finanssi- ja vakuutusmatematiikasta, ja hän kehittää sovelluksia, REST-rajapintoja ja dataputkia Pythonilla ja R:llä.'
  },
  card: {
    cta: 'Näytä profiili'
  },
  profile: {
    overview: 'Tiimi',
    membersLabel: 'Tiimin jäsenet'
  }
};
